export default "__VITE_ASSET__BQELPf2D__"